import { Navigate, Route, Routes } from 'react-router-dom'
import React, { useContext, useEffect } from 'react'

import HomePage from 'pages/Home'
import UsersPage from 'pages/UsersManagement'
import ChangeEmailPage from 'pages/ChangeEmail'
import ProfilePage from 'pages/ProfileManagement'
import AboutPage from 'flow/SiteProposal/pages/About'
import MapPage from 'flow/SiteProposal/pages/Map'
import MonitoringPage from 'flow/SiteProposal/pages/Monitoring'
import DetailsPage from 'flow/SiteProposal/pages/Details'
import SiteProposalAssessmentPage from 'flow/SiteProposal/pages/Assessment'
import Calculations from 'flow/SiteProposal/pages/Calculations'
import { ProfileContext } from 'providers/profile'
import { canManageUsers } from 'utils/rolePermissions'
import { SECRETARIAT_ROLE_ID, RFP_ROLE_ID } from 'constants/roles'
import SitesManagement from 'pages/SitesManagement'
import Reports from 'pages/Reports'
import SiteProposalFlow from 'flow/SiteProposal'
import { SocketProvider } from 'providers/socket'
import ReactGA from 'react-ga'
import REACT_APP_GA_TRACKING_CODE from 'constants/googleAnalyticsCode'
import SitesMap from 'pages/SitesMap'
import SensitiveSpeciesManagement from 'pages/SensitiveSpeciesManagement'

import {
  ROOT_PATH,
  USERS_PATH,
  CHANGE_EMAIL_PATH,
  SITES_PATH,
  SITES_MAP_PATH,
  PROFILE_PATH,
  LEGAL_TERM_PATH,
  COOKIE_SETTINGS_PATH,
  REPORTS_PATH,
  REPORTS_EXPAND_PATH,
  SITE_PROPOSAL_PATH,
  SITE_REASSESSMENT_PATH,
  SITE_EDIT_ONLY_PATH,
  SENSITIVE_SPECIES_PATH
} from './constants'
import TermsAndUse from 'pages/TermsAndUse'
import CookiesContainer from '../features/CookiesContainer'
import SitesModalProvider from 'providers/sitesProviders'

ReactGA.initialize(REACT_APP_GA_TRACKING_CODE)

const RoutesList = () => {
  const { profile } = useContext(ProfileContext)

  return (
    <Routes>
      <Route path={ROOT_PATH} element={<HomePage />} />
      <Route path={PROFILE_PATH} element={<ProfilePage />} />
      <Route
        path={USERS_PATH}
        element={
          canManageUsers(profile.Role.id) ? (
            <UsersPage />
          ) : (
            <Navigate to={ROOT_PATH} replace />
          )
        }
      />
      <Route path={CHANGE_EMAIL_PATH} element={<ChangeEmailPage />} />
      <Route path={SITES_PATH} element={<SitesManagement />} />
      <Route path={SITES_MAP_PATH} element={<SitesMap />} />
      <Route path={REPORTS_PATH} element={<Reports />} />
      <Route path={REPORTS_EXPAND_PATH} element={<Reports />} />
      <Route
        path={SENSITIVE_SPECIES_PATH}
        element={
          [SECRETARIAT_ROLE_ID, RFP_ROLE_ID].includes(profile.Role.id) ? (
            <SensitiveSpeciesManagement />
          ) : (
            <Navigate to={ROOT_PATH} replace />
          )
        }
      />
      <Route path={LEGAL_TERM_PATH} element={<TermsAndUse />} />
      <Route path={COOKIE_SETTINGS_PATH} element={<CookiesContainer />} />
      <Route path={SITE_PROPOSAL_PATH} element={<SiteProposalFlow />}>
        <Route path="about" element={<AboutPage />} />
        <Route path="map" element={<MapPage />} />
        <Route path="monitoring" element={<MonitoringPage />} />
        <Route path="details" element={<DetailsPage />} />
        <Route path="assessment" element={<SiteProposalAssessmentPage />} />
        <Route path="kba-criterias" element={<Calculations />} />
      </Route>
      <Route path={SITE_REASSESSMENT_PATH} element={<SiteProposalFlow />}>
        <Route path="about" element={<AboutPage />} />
        <Route path="map" element={<MapPage />} />
        <Route path="monitoring" element={<MonitoringPage />} />
        <Route path="details" element={<DetailsPage />} />
        <Route path="assessment" element={<SiteProposalAssessmentPage />} />
        <Route path="kba-criterias" element={<Calculations />} />
      </Route>
      <Route path={SITE_EDIT_ONLY_PATH} element={<SiteProposalFlow />}>
        <Route path="about" element={<AboutPage />} />
        <Route path="map" element={<MapPage />} />
        <Route path="monitoring" element={<MonitoringPage />} />
        <Route path="details" element={<DetailsPage />} />
        <Route path="assessment" element={<SiteProposalAssessmentPage />} />
        <Route path="kba-criterias" element={<Calculations />} />
      </Route>
      <Route path="*" element={<Navigate to={ROOT_PATH} replace />} />
    </Routes>
  )
}

const Routing = () => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search)
  })
  return (
    <SocketProvider>
      <SitesModalProvider>
        <RoutesList />
      </SitesModalProvider>
    </SocketProvider>
  )
}

export default Routing
